<template>
  <div>
    <c-list
      :data="list.items"
      :columns="cList.columns"
      :total="list.total"
      :page-current="listPageCurrent"
      :search-where="listSearchWhere"
      @selection-change="handleListSelectionChange"
    >
      <c-list-header>
        <c-list-operations>
          <Button type="primary" @click="$router.push('/dresses/brands/arts/list')">到作品列表添加</Button>
          <c-bulk-delete
            :selected-items="listSelectedItems"
            @ok="confirmDelete"
          ></c-bulk-delete>
          <Button type="primary" @click="$router.back()">返回</Button>
        </c-list-operations>
        <c-list-search>
          <Form
            class="c-form c-form--search"
            inline
            @submit.native.prevent="search"
          >
            <Form-item prop="status">
              <Select
                class="c-form__input"
                placeholder="请选择状态"
                clearable
                v-model="cList.cSearch.where.status.$eq"
              >
                <Option
                  v-for="item in dicts.PublishStatus"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                  >{{ item.label }}
                </Option>
              </Select>
            </Form-item>
            <Form-item>
              <Button type="primary" @click="search">查询</Button>
            </Form-item>
          </Form>
        </c-list-search>
      </c-list-header>
    </c-list>
    <c-artshowitem-list-form ref="form" @get-list="getList"></c-artshowitem-list-form>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import ArtsshowitemForm from "./form";
import RouteParamsMixin from "view-ui-admin/src/mixins/route-params";
import ListMixin from "view-ui-admin/src/mixins/list";

const module = "artshowitem";
const initWhere = {
  artshowId: {
    $eq: ""
  },
  status: {
    $eq: ""
  }
};

@Component({
  mixins: [RouteParamsMixin, ListMixin],
  components: {
    'c-artshowitem-list-form': ArtsshowitemForm
  },
  computed: mapState({
    list: state => state[module].list
  })
})
export default class extends Vue {
  data() {
    const { ListColumnWidth } = this.$consts;

    return {
      cList: {
        columns: [
          {
            type: "selection",
            width: 60
          },
          {
            title: "画展",
            key: "artshowId",
            minWidth: ListColumnWidth.Title,
            render: (h, { row }) => h("span", row.artshow.title)
          },
          {
            title: "艺术家",
            key: "artistId",
            minWidth: ListColumnWidth.Title,
            render: (h, { row }) => h("span", row.artist.name)
          },
          {
            title: "作品标题",
            key: "artistId",
            minWidth: ListColumnWidth.Title,
            render: (h, { row }) => h("span", row.arts.title)
          },
          {
            title: "作品封面",
            width: 200,
            render: (h, { row }) => {
              return h("c-list-image", {
                props: {
                  src: this.$helpers.getImageUrl({
                    id: row.arts.image,
                    width: 150,
                    height: 100
                  })
                }
              });
            }
          },
          {
            title: "获赞",
            key: "zhan",
            width: 100,
          },
          {
            title: "访问量",
            key: "fangwen",
            width: 100,
          },
          {
            title: "状态",
            width: 80,
            render: (h, { row }) =>
              h(
                "span",
                null,
                this.$helpers.getItem(
                  this.dicts.PublishStatus,
                  "value",
                  row.status
                )["label"]
              )
          },
          {
            title: "操作",
            key: "action",
            width: 340,
            render: (h, { row }) =>
              h("div", [
                h(
                  "Button",
                  {
                    on: {
                      click: () => {
                        this.$refs.form.show(row);
                      }
                    }
                  },
                  "编辑"
                ),
                
                h("c-dropdown", {
                  props: {
                    width: 90,
                    title: "修改状态",
                    options: this.dicts.PublishStatus
                  },
                  on: {
                    click: action => {
                      this.changeStatus(row.id, action);
                    }
                  }
                }),
                h("c-confirm-button", {
                  props: {
                    buttonText: "删除",
                    confirmText: "确认删除？"
                  },
                  on: {
                    ok: () => {
                      this.confirmDelete(row.id);
                    }
                  }
                })
              ])
          }
        ],
        cSearch: {
          where: this.$helpers.deepCopy(initWhere)
        }
      }
    };
  }

  async beforeRouteUpdate(to, from, next) {
    initWhere.artshowId = {
         $eq: this.$route.query.id
    }
    this.initListSearchWhere(initWhere);
    this.getList();
    next();
  }

  async created() {
    initWhere.artshowId = {
         $eq: this.$route.query.id
    }
    this.initListSearchWhere(initWhere);
    this.getList();
  }

  getList() {
    return this.$store.dispatch(`${module}/getList`, {
      query: {
        offset: (this.listPageCurrent - 1) * this.$consts.PageSize,
        limit: this.$consts.PageSize,
        where: this.cList.cSearch.where,
        order: [["createdAt", "DESC"]],
        include: [
          {
            model: "Artshow",
            as: "artshow"
          },
          {
            model: "Artist",
            as: "artist"
          },
          {
            model: "Arts",
            as: "arts"
          }
        ]
      }
    });
  }

  async confirmDelete(ids) {
    await this.$store.dispatch(`${module}/delete`, { id: ids });
    this.$Message.success("删除成功");

    const { items } = await this.getList();
    !items.length && this.goListPrevPage();
  }

  async changeStatus(id, action) {
    await this.$store.dispatch(`${module}/put`, {
      id,
      body: {
        status: action
      }
    });
    this.$Message.success("修改状态成功");
    this.getList();
  }

  async order(id, action) {
    await this.$store.dispatch(`${module}/postAction`, {
      id,
      action: "order",
      query: {
        where: this.listSearchWhere || initWhere
      },
      body: { action }
    });

    this.$Message.success("排序成功");
    this.getList();
  }
}
</script>
